import * as React from 'react'
import Select from 'react-select';
import { useFieldState, useFieldApi, useField, FormError } from 'informed';

export interface MultiSelectProps {
    id: string;
    disabled?: boolean;
    field: string;
    className?: string;
    options: any[];
    labelKey: string;
    valueKey: string;
    onChange?: () => void;
    onBlur?: (e) => void;
    validate?: (value: any, values: any[]) => FormError;
    multi?: boolean;
    allowSelectAll?: boolean;
    menuPlacement?: 'top' | 'bottom' | 'auto',
}

export const MultiSelect = ({ field, className, options, labelKey, valueKey, onChange, onBlur, multi, allowSelectAll, validate, ...props }: MultiSelectProps) => {
    const { fieldState, fieldApi } = useField({ field: field, validate: validate });
    const { setValue, setTouched, getError } = fieldApi;

    const vitalographStyles = {
        control: (provided) => ({
            ...provided,
            borderColor: '#e5e5e5',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#555555'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#555555'
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
        })
    }

    const allOption = {
        [labelKey]: "Select All",
        [valueKey]: "*"
    };

    return (<>
        <Select
            menuPlacement={props.menuPlacement}
            name={field}
            isDisabled={props.disabled}
            styles={vitalographStyles}
            options={allowSelectAll ? [allOption, ...options] : options}
            value={fieldState.value ? fieldState.value : null}
            classNamePrefix="multiSelect"
            getOptionLabel={o => o[labelKey]}
            getOptionValue={o => o[valueKey]}
            onChange={(e) => {
                if (allowSelectAll && e && e.includes(allOption)) {
                    setValue(options);
                }
                //A multiselect with multi=true passes an array when it changes, but it can be empty.
                //An empty array is considered a null value
                else if (e && Array.isArray(e)) {
                    e.length > 0 ? setValue(e) : setValue(null);
                } else {
                    setValue(e);
                }

                if (onChange)
                    onChange();
            }}
            onBlur={e => {
                setTouched(true);
                if (onBlur) {
                    onBlur(e);
                }
            }}
            isMulti={multi}
            {...props}
        />
        {getError() ? (
            <span className="field-validation-error">{getError()}</span>
        ) : null}
    </>);
}
